import PropTypes from "prop-types";
import { withTranslation } from "@template/components/translation";
import PricingRow from "../PricingRow";
import GermanVATIncluded from "./GermanVATIncluded";
import USSalesTax from "./USSalesTax";

const SubTotal = ({ text, formatTranslation, countryCode, storeCode }) => {
  if (!text) {
    return null;
  }

  return (
    <PricingRow>
      <p>
        {formatTranslation("minibag_subtotal_title")}
        <USSalesTax countryCode={countryCode} />
      </p>
      <div data-test-id="miniBagSubTotal">
        {text}
        <GermanVATIncluded storeCode={storeCode} />
      </div>
    </PricingRow>
  );
};

SubTotal.defaultProps = {
  text: null
};

SubTotal.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  text: PropTypes.string,
  countryCode: PropTypes.string.isRequired,
  storeCode: PropTypes.string.isRequired
};

export default withTranslation(SubTotal);
